import { h } from 'preact'

import { TITLES } from '../../../config'
import { withClassName } from '../../util/Styles'
import NavLink from '../../atom/NavLink'
import { HorizontalNavMenu, HorizontalNavMenuEntry } from '../../atom/HorizontalMenu'
import { SIDE_LEFT, SIDE_RIGHT } from '../../../constants'

import styles from './index.module.scss'

const ArchiveNavigationMenuEntry = withClassName(
  HorizontalNavMenuEntry,
  styles['m-article-navigation__menu-entry'],
)

const ArchiveNavigation = (props) => {
  const { prev, archives, next, ...rest } = props

  return (
    <HorizontalNavMenu {...rest}>
      <ArchiveNavigationMenuEntry side={SIDE_LEFT}>
        {prev && (
          <NavLink
            href={prev}
            title={prev.title}
            rel="prev"
          >
            {TITLES.PREV}
          </NavLink>
        )}
      </ArchiveNavigationMenuEntry>

      {archives && (
        <ArchiveNavigationMenuEntry>
          <NavLink href={archives} internal>{TITLES.ARCHIVES}</NavLink>
        </ArchiveNavigationMenuEntry>
      )}

      <ArchiveNavigationMenuEntry side={SIDE_RIGHT}>
        {next && (
          <NavLink
            href={next}
            title={next.title}
            rel="next"
          >
            {TITLES.NEXT}
          </NavLink>
        )}
      </ArchiveNavigationMenuEntry>
    </HorizontalNavMenu>
  )
}

export default ArchiveNavigation
